import { showGlobalErrorModal } from "./showGlobalErrorModal";

import type { QueryDefaultsConfig, MutationDefaultsConfig, CustomMutationMeta, CustomQueryMeta } from "./types";
import type { QueryClientConfig, Query, Mutation } from "@tanstack/react-query";

const shouldShowErrorModal = (meta: CustomMutationMeta | CustomQueryMeta | undefined): boolean => {
    return !meta?.disableBaseErrorModal;
};

export const enhanceQueryDefaults = (options?: QueryDefaultsConfig): QueryDefaultsConfig => {
    const merged: QueryDefaultsConfig = { ...(options ?? {}) };
    const userOnError = merged.onError;

    return {
        ...merged,
        onError: (error, query) => {
            const queryInstance = query as Query;
            const meta = queryInstance.options.meta as CustomQueryMeta | undefined;
            if (shouldShowErrorModal(meta)) {
                showGlobalErrorModal(error);
            }
            userOnError?.(error, query);
        },
    };
};

export const enhanceMutationDefaults = (options?: MutationDefaultsConfig): MutationDefaultsConfig => {
    const merged: MutationDefaultsConfig = { ...(options ?? {}) };
    const userOnError = merged.onError;

    return {
        ...merged,
        onError: (error, variables, context, mutation) => {
            const mutationInstance = mutation as Mutation;
            const meta = mutationInstance.options.meta as CustomMutationMeta | undefined;
            if (shouldShowErrorModal(meta)) {
                showGlobalErrorModal(error);
            }
            userOnError?.(error, variables, context, mutation);
        },
    };
};

export const DEFAULT_QUERY_CLIENT_CONFIG: QueryClientConfig = {
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
};
